import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { NSCommonConstants } from '@ruby/configs/common.constants';
import { IThirdPartyEid } from '@ruby/modules/third-party/models/third-party.interface';
import { selectThirdPartyAuthorizationsState } from '@ruby/modules/third-party/store';
import { fromThirdPartyAuthorization, ThirdPartyAuthorizationActions } from '@ruby/modules/third-party/store/third-party-authorization.index';
import { ThirdPartyCompaniesActions } from '@ruby/modules/third-party/store/third-party-companies.index';
import { IStation } from '@ruby/shared/models/commons/station.interface';
import { IStcc } from '@ruby/shared/models/rate-inquiry/stcc.interface';

@Component({
  selector: 'ng-third-party-request-eid-container',
  template: `
    <ng-third-party-request-eid *ngIf="(state$ | async) as store"
                                [states]="store.states"
                                [destinationStations]="store.destinationStations"
                                [isLoadingDS]="store.isLoadingDS"
                                [isLoadingStcc]="store.isLoadingStcc"
                                [stccList]="store.stcc"
                                (loadOriginStationsData)="loadOriginStations($event)"
                                (request)="request($event)"
                                (loadStccData)="loadStcc($event)">
    </ng-third-party-request-eid>
  `
})
export class ThirdPartyRequestEidContainerComponent {
  state$!: Observable<fromThirdPartyAuthorization.State>;

  constructor(private store: Store) {
    this.state$ = this.store.select(selectThirdPartyAuthorizationsState);
    this.store.dispatch(ThirdPartyAuthorizationActions.loadStates());
  }

  /**
   * Request
   *
   * @summary Dispatch an action to request new EID
   * @param $event: IThirdPartyEid
   * @returns void
   */
  request($event: IThirdPartyEid): void {
    this.store.dispatch(ThirdPartyCompaniesActions.requestEid({ data: $event }));
  }

  /**
   * Load Origin Stations
   *
   * @summary Called to load the origin and destination
   * @param $event: IStation
   * @returns void
   */
  loadOriginStations($event: IStation): void {
    if ($event.station.length > 2) {
      this.store.dispatch(ThirdPartyAuthorizationActions.loadDestinationStations({ data: $event }));
    } else {
      this.store.dispatch(ThirdPartyAuthorizationActions.setDestinationStations({ data: [] }));
    }
  }

  /**
   * Load STCC
   *
   * @summary Called when an event is emitted from the component
   * @param $stcc: string
   * @returns void
   */
  loadStcc($stcc: string): void {
    const request: IStcc = {};
    if ($stcc.match(NSCommonConstants.stccRegexNum)) {
      request.stccCode = {
        searchType: 'STARTSWITH',
        value: $stcc
      };
    }
    if ($stcc.match(NSCommonConstants.stccRegexAlpha)) {
      request.stccDescription = {
        searchType: 'CONTAINS',
        value: $stcc
      };
    }
    this.store.dispatch(ThirdPartyAuthorizationActions.loadStcc({ data: request }));
  }
}
